(function () {
  'use strict';
  angular.module('vcreminder')
    .component('clientlog', {
      restrict: 'E',
      bindings: {
        clientid: '<',
        mode: '<?'
      },
      template: `
      <h4>Logbuch</h4>
      <!-- Add new logentry -->
      <form class="form-vertical spacer-bottom">
        <div class="input-group">
          <input type="text" ng-model="vm.newlogentry" class="form-control" id="newlog"
                 placeholder="Neuer Logeintrag">
          <span class="input-group-btn">
            <button class="btn btn-success" type="submit" ng-click="vm.addLogEntry()">
              <i class="fa fa-plus"></i>
            </button>
          </span>
        </div>
      </form>
      <!-- Show logs -->
      <div class="myscrollbox spacer-bottom scrollwindow">
        <dl class="dl-vertical" ng-repeat="le in vm.logs | orderBy: '-created' ">
          <dt ng-bind="le.created | moment: 'll' "></dt>
          <dd ng-bind="le.entry"></dd>
        </dl>
      </div>
      <div class="alert alert-info spacer-top" ng-hide="vm.logs.length > 0">Keine Logeinträge</div>

      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Reminder', 'ClientHelper', 'Clientlog', 'vertxEventBusService',
        function ($log, $http, Rlog, Reminder, ClientHelper, Clientlog, vertxEventBusService) {

          let vm = this;

          vm.addLogEntry = addLogEntry;

          vm.$onInit = function () {
            vm.newlogentry = '';
            let query = {};
            if (!angular.isDefined(vm.mode) || vm.mode !== 'patient') {
              vm.mode = 'client';
            }


            if (angular.isDefined(vm.clientid)) {
              if (vm.mode === 'patient') {
                query = {patientid: vm.clientid};
              } else {
                query = {clientid: vm.clientid};
              }

              Clientlog.$search(query).$then(function (logs) {
                vm.logs = logs;
              }, function (err) {
                $log.error('clientlog not found , id: ', vm.clientid);
                Rlog.error('reminder', 'clientlog', 'clientlog search failed', {clientid: vm.clientid, mode: vm.mode});
              });
            }
          };

          function addLogEntry() {
            let logentry = {};
            logentry.created = moment().toISOString();
            logentry.clientid = vm.clientid;
            logentry.patientid = vm.clientid;
            logentry.entry = vm.newlogentry;
            Clientlog.$create(logentry).$then(function () {
              vm.newlogentry = '';
            }, function (err) {
              $log.error('logentry state could not be added: ', vm.newlogentry);
              Rlog.error('reminder', 'clientlog', 'logentry add  failed', {clientid: vm.clientid});
            });
          }


          const clUpdateHandler = function (message) {
            let messages = message.split(':');
            $log.debug('clientlogs updated: ', message);
            if (angular.isDefined(vm.logs)){
              vm.logs.$refresh();
            }
          };

          // listen for clientlog updates
          vertxEventBusService.on('clientlogs.update', {}, clUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('clientlogs.update', {}, clUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
